export default "__VITE_ASSET__9732ebec__"